import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import GeneralErrorPage from './GeneralErrorPage.js';
import {
  canAttemptSilentAuthentication,
  clearSilentAuthenticationAttempt,
  startSilentAuthentication,
} from '../../../services/ssoService.js';

const wasPageReloaded = () => {
  if (
    typeof performance === 'undefined' ||
    typeof performance.getEntriesByType !== 'function'
  ) {
    return false;
  }

  const navigationEntry = performance.getEntriesByType('navigation')[0];

  return navigationEntry?.type === 'reload';
};

const UnauthorizedAccessPage = ({ type }) => {
  useEffect(() => {
    if (!wasPageReloaded()) {
      return;
    }

    clearSilentAuthenticationAttempt();

    if (canAttemptSilentAuthentication()) {
      startSilentAuthentication('/');
    }
  }, []);

  return <GeneralErrorPage type={type} />;
};

UnauthorizedAccessPage.propTypes = {
  type: PropTypes.object,
};

export default UnauthorizedAccessPage;
